// Joya Headquarter — shared Hebrew strings (shell, components, shared vocabulary).
// Same keys as common.en.js. Page strings live in the group files next to this one.
export default {
  // App shell and login (keys without the joya. prefix)
  'account.signOut': 'התנתק',
  'common.language': 'שפה',
  'common.sessionExpiredSignIn': 'ההתחברות שלך פגה. טען את הדף מחדש והתחבר.',
  'menu.open': 'תפריט',
  'menu.close': 'סגור',
  'login.title': 'Joya Headquarter',
  'login.failed': 'הכניסה נכשלה',
  'login.network': 'שגיאת רשת — האם השרת זמין?',
  'login.username': 'אימייל (כמו באדמין של Allegro)',
  'login.password': 'סיסמה',
  'login.signingIn': 'מתחבר…',
  'login.signIn': 'כניסה',
  'joya.back': '→ חזרה',
  'joya.loading': 'טוען…',
  'joya.unknown': 'לא ידוע',
  'joya.unknownTitle': 'הנתון חסר — הוא לא נחשב כאפס',
  'joya.noAccess': 'למשתמש הזה אין גישה למטה ג׳ויה. מנהל הרשת יכול לתת גישה בהגדרות.',
  'joya.demoBanner': 'נתוני הדגמה — המספרים כאן מומצאים לצורך הדגמה ואינם נתונים אמיתיים של ג׳ויה.',
  'joya.source': 'מקור',
  'joya.period': 'תקופה',
  'joya.updated': 'עודכן',
  'joya.location': 'סניף',
  'joya.allLocations': 'כל הסניפים',
  'joya.company': 'חברה',
  'joya.allCompanies': 'כל החברות',
  'joya.allCompanyLocations': 'כל הסניפים בחברה',
  'joya.noCompany': 'ללא חברה',
  'joya.chooseLocation': 'בחרו סניף בראש העמוד.',
  'joya.save': 'שמירה',
  'joya.cancel': 'ביטול',
  'joya.edit': 'עריכה',
  'joya.delete': 'מחיקה',
  'joya.add': 'הוספה',
  'joya.approve': 'אישור',
  'joya.reject': 'דחייה',
  'joya.close': 'סגירה',
  'joya.note': 'הערה',
  'joya.noteOptional': 'הערה (לא חובה)',
  'joya.by': 'על ידי',
  'joya.at': 'בתאריך',
  'joya.none': 'אין כרגע.',
  'joya.demo': 'הדגמה',
  'joya.estimate': 'הערכה',
  'joya.known': 'ידוע',
  'joya.missing': 'חסר',
  'joya.from': 'מתאריך',
  'joya.to': 'עד תאריך',
  'joya.details': 'פרטים',
  'joya.history': 'היסטוריה',
  'joya.whoWhen': '{who} · {when}',

  'joya.role.CHAIN_ADMIN': 'הנהלת רשת',
  'joya.role.LOCATION_MANAGER': 'מנהל/ת סניף',

  'joya.nav.label': 'ניווט במטה ג׳ויה',
  'joya.nav.main': 'תפריט ראשי',
  'joya.nav.stock': 'מלאי ורכש',
  'joya.nav.manpower': 'כח אדם',
  'joya.nav.performance': 'ביצועים',
  'joya.files.attach': "צירוף קובץ",
  'joya.files.dropHere': "שחררו כאן את הקבצים — הם ייבדקו לפני שמירה",
  'joya.files.close': "סגירה",
  'joya.files.status.checking_one': "בודק את הקובץ…",
  'joya.files.status.checking_other': "בודק {count} קבצים…",
  'joya.files.status.checked_one': "הקובץ נבדק. בדקו את הפרטים ולחצו \"ייבוא\".",
  'joya.files.status.checked_other': "{count} קבצים נבדקו. בדקו את הפרטים ולחצו \"ייבוא\".",
  'joya.files.status.importing_one': "מייבא…",
  'joya.files.status.importing_other': "מייבא…",
  'joya.files.status.imported_one': "הייבוא הסתיים",
  'joya.files.status.imported_other': "הייבוא הסתיים",
  'joya.files.status.failed_one': "לא ניתן לבדוק את הקובץ",
  'joya.files.status.failed_other': "לא ניתן לבדוק את הקבצים",
  'joya.files.period': "תקופה",
  'joya.files.previous': "הקובץ הזה כבר הועלה ({times} פעמים). ייבוא נוסף לא יכפיל שורות שכבר נשמרו.",
  'joya.files.useAdmin': "את הקובץ הזה מייבאים בעמוד העלאת הקבצים באדמין:",
  'joya.files.adminPage': "העלאת קבצים",
  'joya.files.chooseBranch': "בחרו סניף",
  'joya.files.import_one': "ייבוא",
  'joya.files.import_other': "ייבוא {count} קבצים",
  'joya.files.failed': "נכשל",
  'joya.files.result.OK': "נשמר",
  'joya.files.result.PARTIAL': "נשמר בחלקו",
  'joya.ask.downloadExcel': 'הורדה לאקסל',
  'joya.ask.suggestions': 'הצעות לשאלה',
  'joya.area.askTitle': 'מה תרצו לדעת?',
  'joya.area.placeholder': 'כתבו שאלה…',
  'joya.area.stock.title': 'מלאי ורכש',
  'joya.area.stock.intro': 'שאלו על הזמנות, חוסרים ומה נמכר. לחצו על השדה כדי לראות הצעות לשאלה.',
  'joya.area.stock.s1': 'מה כדאי להזמין למחר?',
  'joya.area.stock.s2': 'אילו חוסרים דווחו השבוע?',
  'joya.area.stock.s3': 'מה המערכת למדה מההזמנות שלנו?',
  'joya.area.stock.s4': 'אילו מנות נמכרו הכי הרבה השבוע?',
  'joya.area.stock.s5': 'אילו מנות ירדו במכירות לעומת השבוע שעבר?',
  'joya.area.stock.s6': 'אילו פריטים מנהל הסניף משנה הכי הרבה ברשימת ההזמנה?',
  'joya.area.stock.s7': 'אילו רשימות הזמנה מחכות לאישור?',
  'joya.area.stock.s8': 'מה חסר בנתונים כדי להמליץ על הזמנה?',
  'joya.area.stock.s9': 'אילו פריטים חסרו הכי הרבה פעמים בחודש האחרון?',
  'joya.area.stock.s10': 'כמה מנות מכל סוג נמכרו בחודש שעבר?',
  'joya.area.people.title': 'כח אדם',
  'joya.area.people.intro': 'שאלו על משמרות, עובדים, שעות ושכר. לחצו על השדה כדי לראות הצעות לשאלה.',
  'joya.area.people.s1': 'כמה עובדים צריך בכל משמרת בשבוע הבא?',
  'joya.area.people.s2': 'מה עלות העבודה באחוז מההכנסות החודש?',
  'joya.area.people.s3': 'איפה עבדנו יותר שעות ממה שתוכנן?',
  'joya.area.people.s4': 'אילו משמרות היו הכי עמוסות בשבוע שעבר?',
  'joya.area.people.s5': 'אילו בעיות יש בהכנת השכר החודש?',
  'joya.area.people.s6': 'אילו כללי איוש חלים על הסניף?',
  'joya.area.people.s7': 'כמה שעות עבדו בשבוע שעבר לעומת התכנון?',
  'joya.area.people.s8': 'באילו ימים בשבוע הבא צריך הכי הרבה עובדים?',
  'joya.area.people.s9': 'אילו החלטות על משמרות מחכות לאישור?',
  'joya.area.people.s10': 'מה עלות העבודה בכל סניף בחודש שעבר?',
  'joya.area.people.s11': 'כמה טבחים צריך ביום שישי בבוקר?',
  'joya.area.people.s12': 'אילו נתוני נוכחות חסרים?',
  'joya.area.performance.title': 'ביצועים',
  'joya.area.performance.intro': 'שאלו על מכירות, סועדים ועלויות לפי סניף ותקופה. לחצו על השדה כדי לראות הצעות לשאלה.',
  'joya.area.performance.s1': 'דוח ביצועים שבועי: ממוצע ההכנסה היומי החודש מול אותו חודש בשנה שעברה',
  'joya.area.performance.s2': 'ביצועי מלצרים החודש',
  'joya.area.performance.s3': 'דשבורד יומי: הכנסות היום לפי מסעדה, סועדים, הכנסה לסועד וזיכויים',
  'joya.nav.bank': 'בנק',
  'joya.area.bank.title': 'בנק',
  'joya.area.bank.intro': 'שאלו על חשבון הבנק של החברה: יתרה, כסף שנכנס ויצא, הפקדות ותשלומים. הנתונים מקובץ הבנק האחרון שהועלה. לחצו על השדה כדי לראות הצעות לשאלה.',
  'joya.area.bank.s1': 'מה היתרה בחשבון הבנק היום?',
  'joya.area.bank.s2': 'כמה כסף נכנס ויצא החודש?',
  'joya.area.bank.s3': 'כמה העבירה וולט החודש?',
  'joya.area.bank.s4': 'כמה נכנס מחברות האשראי בשבוע שעבר?',
  'joya.area.bank.s5': 'מה התשלומים הגדולים החודש?',
  'joya.area.bank.s6': 'אילו שיקים נפרעו השבוע?',
  'joya.area.bank.s7': 'מתי היתרה הייתה הכי נמוכה החודש?',
  'joya.area.bank.s8': 'כמה שילמנו למע"מ ולביטוח לאומי השנה?',
  'joya.role.ACCOUNTANT': "הנהלת חשבונות",
  'joya.nav.accounting': "הנהלת חשבונות",
  'joya.area.accounting.title': "הנהלת חשבונות",
  'joya.area.accounting.intro': "שאלו על התאמה בין הקופה לבנק: האם הכסף מכרטיסי האשראי, וולט ותשלומים אחרים הגיע לחשבון, ומה היו העמלות. לחצו על השדה כדי לראות הצעות לשאלה.",
  'joya.area.accounting.s1': "השווה אשראי בקופה לכסף שנכנס בבנק, לפי שבועות, החודש",
  'joya.area.accounting.s2': "האם כל כסף האשראי של השבוע שעבר הגיע לבנק?",
  'joya.area.accounting.s3': "כמה עמלה גבתה מקס בחודש שעבר?",
  'joya.area.accounting.s4': "האם תשלומי אמריקן אקספרס של החודש שעבר הגיעו?",
  'joya.area.accounting.s5': "השווה את מכירות וולט בקופה להעברות של וולט בבנק החודש",
  'joya.area.accounting.s6': "כמה כסף אשראי צפוי להיכנס השבוע?",
  'joya.area.accounting.s7': "באילו שבועות יש הפרש לא רגיל בין הקופה לבנק?",
  'joya.area.accounting.s8': "כמה מזומן נרשם בקופה החודש?",
  'joya.nav.areas': 'אזורי עבודה',
  'joya.nav.overview': 'סקירת הרשת',
  'joya.nav.workspace': 'סביבת עבודה של הסניף',
  'joya.nav.orders': 'הזמנות והשלמת מלאי',
  'joya.nav.staffing': 'תכנון משמרות',
  'joya.nav.ordering': 'הזמנות',
  'joya.nav.shortages': 'דיווח חוסרים',
  'joya.nav.learned': 'מה המערכת למדה',
  'joya.nav.people': 'כוח אדם ושכר',
  'joya.nav.rules': 'כללי איוש ומשמרות',
  'joya.nav.labor': 'עלות עבודה',
  'joya.nav.payroll': 'בדיקות הכנת שכר',
  'joya.nav.employees': 'עובדים ומיפוי מזהים',
  'joya.nav.hq': 'מטה',
  'joya.nav.sales': 'מכירות וביצועים',
  'joya.nav.tasks': 'משימות',
  'joya.nav.ask': 'שאלו את המטה',
  'joya.nav.data': 'נתונים',
  'joya.nav.import': 'ייבוא והזנה ידנית',
  'joya.nav.menu': 'תפריט ורכיבים',
  'joya.nav.settings': 'הגדרות',

  'joya.status.DRAFT': 'טיוטה',
  'joya.status.APPROVED': 'מאושר',
  'joya.status.ORDERED': 'הוזמן בפועל',
  'joya.status.REJECTED': 'נדחה',
  'joya.status.OPEN': 'פתוח',
  'joya.status.IN_PROGRESS': 'בטיפול',
  'joya.status.DONE': 'בוצע',
  'joya.status.CANCELLED': 'בוטל',
  'joya.status.CORRECTED': 'תוקן',
  'joya.status.ACCEPTED': 'אושר כתקין',
  'joya.status.DISMISSED': 'לא בעיה',
  'joya.status.NEW': 'חדש',
  'joya.status.DRAFT_READY': 'טיוטת תשובה מוכנה',
  'joya.status.RESPONDED': 'נענה',
  'joya.status.CLOSED': 'סגור',

  'joya.wd.0': 'ראשון',
  'joya.wd.1': 'שני',
  'joya.wd.2': 'שלישי',
  'joya.wd.3': 'רביעי',
  'joya.wd.4': 'חמישי',
  'joya.wd.5': 'שישי',
  'joya.wd.6': 'שבת',

  'joya.unit.DINERS_PER_SHIFT': 'סועדים במשמרת',
  'joya.unit.DINERS_PEAK_HOUR': 'סועדים בשעת השיא',
  'joya.unit.CONCURRENT_DINERS_PEAK': 'סועדים בו-זמנית (שיא)',
  'joya.unit.ORDERS_PER_SHIFT': 'הזמנות (חשבונות) במשמרת',
  'joya.unit.ORDERS_PEAK_HOUR': 'הזמנות (חשבונות) בשעת השיא',
  'joya.unitHelp.DINERS_PER_SHIFT': 'סכום הסועדים בחשבונות שנפתחו בזמן המשמרת.',
  'joya.unitHelp.DINERS_PEAK_HOUR': 'השעה העמוסה ביותר במשמרת: סכום הסועדים בחשבונות שנפתחו באותה שעה.',
  'joya.unitHelp.CONCURRENT_DINERS_PEAK': 'הכי הרבה סועדים שישבו באותו רגע (נבדק כל 15 דקות). צריך שעת סגירה של החשבון.',
  'joya.unitHelp.ORDERS_PER_SHIFT': '"הזמנה" = חשבון אחד בקופה (Beecomm) שנפתח בזמן המשמרת.',
  'joya.unitHelp.ORDERS_PEAK_HOUR': 'השעה העמוסה ביותר: מספר החשבונות שנפתחו באותה שעה.',

  'joya.conf.HIGH': 'ביטחון גבוה',
  'joya.conf.MEDIUM': 'ביטחון בינוני',
  'joya.conf.LOW': 'ביטחון נמוך',
  'joya.conf.NONE': 'אין בסיס לכמות',


  'joya.ask.title': 'שאלו או בקשו שינוי',
  'joya.ask.placeholder': 'למשל: למה צריך שלושה טבחים ביום חמישי בבוקר?',
  'joya.ask.send': 'שליחה',
  'joya.ask.delete': 'מחיקת השאלה',
  'joya.ask.loadingOlder': 'טוען שאלות קודמות…',
  'joya.ask.keepNote': 'נשמרות רק {n} השאלות האחרונות',
  'joya.ask.resend': 'שליחת השאלה שוב',
  'joya.ask.edit': 'עריכת השאלה',
  'joya.ask.thinking': 'המטה מחשב ועונה… (בדרך כלל פחות מדקה)',
  'joya.ask.failed': 'לא התקבלה תשובה.',
  'joya.ask.unverified': 'מספרים בתשובה שלא נמצאו בחישובים — בדקו אותם:',
  'joya.ask.howCalculated_one': 'איך זה חושב (חישוב אחד)',
  'joya.ask.howCalculated_other': 'איך זה חושב ({count} חישובים)',
  'joya.ask.rawNumbers': 'הנתונים המלאים',
  'joya.ask.proposal': 'שינוי מוצע — עדיין לא נשמר',
  'joya.ask.apply': 'החלה ושמירה',
  'joya.ask.discard': 'לא, תודה',
  'joya.ask.ps.APPLIED': 'נשמר',
  'joya.ask.ps.DISCARDED': 'בוטל',
  'joya.ask.ps.PENDING': 'ממתין',
  'joya.ask.whatIfNote': 'חישוב "מה אם" — הכללים השמורים לא שונו.',
  'joya.ask.howItWorks': 'המספרים מחושבים במערכת מתוך הנתונים שלכם (לא על ידי מודל השפה), ולכל חישוב מוצגים התקופה והמקור. שינוי נשמר רק אחרי שתאשרו.',
  'joya.ask.op.add': 'הוספה:',
  'joya.ask.op.set_qty': 'שינוי כמות:',
  'joya.ask.op.set': 'שינוי:',
  'joya.ask.op.remove': 'הסרה:',
  'joya.ask.op.restore': 'החזרה:',
  'joya.ask.op.note': 'הערה:',
  'joya.ask.rule.add': 'כלל חדש לצוות —',
  'joya.ask.rule.edit': 'שינוי כלל של הצוות —',
  'joya.ask.rule.remove': 'הסרת כלל של הצוות —',
  'joya.ask.rule.before': 'לפני:',
  'joya.ask.rule.area.ALL': 'כל התחומים',
  'joya.ask.rule.area.STOCK': 'מלאי ורכש',
  'joya.ask.rule.area.MANPOWER': 'כוח אדם ושכר',
  'joya.ask.rule.area.PERFORMANCE': 'ביצועים',
  'joya.ask.rule.area.BANK': 'בנק',
  'joya.ask.rule.area.ACCOUNTING': 'הנהלת חשבונות',
};
